
document.addEventListener('DOMContentLoaded', function () {
  const cards = document.querySelectorAll('.card');
  const mainImage = document.getElementById('main-image');
  const mainTitle = document.getElementById('main-title');
  const mainDescription = document.getElementById('main-description');
  cards.forEach(function (card) {
    card.addEventListener('click', function () {
      const newImageSrc = card.getAttribute('data-image');
      const newTitle = card.getAttribute('data-title');
      const newDescription = card.getAttribute('data-description');
      // Add a fade-out effect before changing content
      mainImage.style.opacity = 0;
      mainTitle.style.opacity = 0;
      mainDescription.style.opacity = 0;
      // Fade out the card
      card.style.opacity = 0;
      // Use setTimeout to wait for the fade-out to finish, then swap content
      setTimeout(function () {
        const tempImageSrc = mainImage.src;
        const tempTitle = mainTitle.textContent;
        const tempDescription = mainDescription.textContent;
        // Update main content with new card data
        mainImage.src = newImageSrc;
        mainImage.alt = newTitle;
        mainTitle.textContent = newTitle;
        mainDescription.textContent = newDescription;
        // Swap card data with the previous main content
        card.setAttribute('data-image', tempImageSrc);
        card.setAttribute('data-title', tempTitle);
        card.setAttribute('data-description', tempDescription);
        card.querySelector('img').src = tempImageSrc;
        card.querySelector('h3').textContent = tempTitle;
        // Fade card back in after content swap
        card.style.opacity = 1;
        // Fade content back in after changes
        mainImage.style.opacity = 1;
        mainTitle.style.opacity = 1;
        mainDescription.style.opacity = 1;
      }, 300); // Set delay to match transition duration (300ms)
    });
  });
});

  function showPopup() {
    document.querySelector('.pxFormGenerator').style.display = 'block';
    let overlay = document.createElement('div');
    overlay.classList.add('overlay');
    overlay.onclick = closePopup; 
    document.body.appendChild(overlay);
  }

  function closePopup() {
    document.querySelector('.pxFormGenerator').style.display = 'none';
    let overlay = document.querySelector('.overlay');
    if (overlay) {
      document.body.removeChild(overlay);
    }
  }